import { Select } from "@commonlibs";
import TextField from "../TextField/TextField";
import styled from "styled-components";

export const IdentificationTypeSelect = styled(Select)(() => ({
    width: 112,
})) as typeof Select;

export const IdentificationCodeField = styled(TextField)(() => ({
    flex: 1,
}));
